const FEATURE_SWITCHES = [
  'pdp-shop-similar',
  'pdp-dash-hudson',
  'pdp-hotspots-outfitting-solution',
  'pdp-style-fit-desc-enabled',
  'social-proofing',
  'pdp-gallery-grid',
  'topRatedBestSeller',
  'has-pdp-guest-session-fetch-mfe',
  'model-measurement-and-jump-link',
  'denim-elevated-and-scales',
  'sticky-atb-desktop-experience',
  'pdp-enable-loudcrowd-script',
  'pdp-has-category-recs',
  'quickview-mfe-product-stylitics',
  'pdp-use-new-swatch-click-analytics',
  'pdp-use-new-add-to-bag-click-analytics',
];

module.exports = {
  FEATURE_SWITCHES,
};
